import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import getMarketplaceDisplayName from '../../../components/data-driven-logo/get-marketplace-display-name';
import { messages } from '../../messages';
import classnames from 'classnames';
import style from './item-info.module.less';

export const ItemInfo = ({ name = '', sku = '', upc = '', showAdjustmentWarning = false, marketplaceId, adjustedToNonZero = false }) => {
  const displayName = getMarketplaceDisplayName(marketplaceId);
  return (
    <div className={style.details}>
      <span className={style.name}>{name}</span>
      <span className={classnames(style['sku-upc'], style['adjustment-aware'])}>
        <div>
          <strong>
            <FormattedMessage {...messages.itemInfoSku} />
          </strong>{' '}
          {sku}
        </div>
        {showAdjustmentWarning && (
          <div
            className={classnames(style['adjustment-wrap'], {
              [style['non-zero']]: adjustedToNonZero,
            })}
          >
            <FormattedMessage
              {...messages.itemInfoMarketplaceAdjustmentMade}
              values={{
                displayName: displayName?.defaultMessage,
                b: (chunks) => <b>{chunks}</b>,
              }}
            />
          </div>
        )}
      </span>
      <span
        className={classnames(style['sku-upc'], {
          [style['below-adjustment']]: showAdjustmentWarning,
        })}
      >
        <strong>
          <FormattedMessage {...messages.itemInfoUpc} />
        </strong>{' '}
        {upc}
      </span>
    </div>
  );
};

ItemInfo.propTypes = {
  adjustedToNonZero: PropTypes.bool,
  name: PropTypes.string,
  sku: PropTypes.string,
  upc: PropTypes.string,
  showAdjustmentWarning: PropTypes.bool,
  marketplaceId: PropTypes.string,
};
